import sharedVars from '../shared_variables';

const getDevice = () => {
    // eslint-disable-next-line max-len
    return ((window.innerWidth < sharedVars['mobile-bp'] && getOrientation() === 'portrait') || (window.innerHeight < sharedVars['mobile-bp'] && getOrientation() === 'landscape')) ? 'mobile' : 'desktop';
};

const getOrientation = () => {
    return (window.innerWidth > window.innerHeight) ? 'landscape' : 'portrait';
};

export { getDevice, getOrientation };
